module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Legion-S2.481c705.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Legion-S2.jpg
// module id = qZcz
// module chunks = 0